/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'

import { deleteQuickLink } from '../../../../assets/ts/data/quick-links'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import usePascodeMetadata from '../../../../hooks/use-pascode-metadata'
import useQuickLinks from '../../../../hooks/use-quick-links'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import { RoleContext } from '../../../../store/role-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
} from '../../../../utils/constants/global-constants'
import NO_RESULTS from '../../../../utils/constants/no-results'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import {
  Dropdown,
  ServicingMAJCOM,
  optionsTypes,
} from '../../../../utils/controls/select-options-data'
import AddEditView from './add-edit-view'

const SettingsQuicklinks = ({
  assignedComponentOptions,
  initialMajcomOptions,
  initialSectionOptions,
  initialSquadronOptions,
  roleContext,
  visibleSquadrons
}: any) => {
  const { components, majcoms, sections } = useContext(MetadataContext)


  const [sectionOptions, setSectionOptions] = useState<any[]>(initialMajcomOptions)
  const [majcomOptions, setMajcomOptions] = useState<any[]>(initialSectionOptions)
  const [squadronOptions, setSquadronOptions] = useState<any[]>(initialSquadronOptions)

  const sectionOption: optionsTypes[] = [
    ALL_SELECT_OPTION,
    ...sections.map(({ Label, Value }) => ({
      label: Label,
      value: Value,
    })),
  ]

  const [dropdownValues, setDropdownValues] = useState<any>({
    assignedComponent: '',
    assignedComponentCode: ALL_SELECT_VALUE,
    section: '',
    sectionCode: ALL_SELECT_VALUE,
    servicingMAJCOM: '',
    servicingMAJCOMCode: ALL_SELECT_VALUE,
    squadron: '',
  })

  const { fetchQuickLinks, quickLinks } = useQuickLinks({
    assignedComponentFilter: dropdownValues.assignedComponentCode,
    assignedComponentOptions: assignedComponentOptions,
    isArchivedFilter: null,
    majcomOptions: initialMajcomOptions,
    roleContext: roleContext,
    sectionCodeFilter: dropdownValues.sectionCode,
    sectionOptions: initialSectionOptions,
    servicingMAJCOMFilter: dropdownValues.servicingMAJCOMCode,
    squadronFilter: dropdownValues.squadron,
    squadronOptions: initialSquadronOptions,
  })
  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })

  const [clickedItem, setClickedItem] = useState<boolean>(false)
  const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
  const [showEdit, setShowEdit] = useState<boolean>(false)

  const onAssignComponentChange = (e: { label: string; value: number }) => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === e.value || e.value === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => e.squadron.includes(maj.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) => 
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions: any = [
      ...majOptions.filter((majcom) => majcom.squadron).map((majcom) => ({
        label: majcom.squadron,
        value: majcom.squadron
      }))
    ]

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION)
    }
    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)
    setDropdownValues((prev) => ({
      ...prev,
      assignedComponent: e.label,
      assignedComponentCode: e.value,
      section:
        sectOptions.length === 1 ? sectOptions[0].label : ALL_SELECT_LABEL,
      sectionCode:
        sectOptions.length === 1 ? sectOptions[0].value : ALL_SELECT_VALUE,
      servicingMAJCOM:
        majOptions.length === 1 ? majOptions[0].label : ALL_SELECT_LABEL,
      servicingMAJCOMCode:
        majOptions.length === 1 ? majOptions[0].value : ALL_SELECT_VALUE,
        squadron:
        squadOptions.length === 1 ? squadOptions[0].value : ALL_SELECT_VALUE,
    }))
  }
  const onMAJCOMChange = (e: { label: string; value: number }) => {
    const sectOptions: any[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (e.squadron.includes(sect.squadron) || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) => 
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions: any = [
      ...majcomOptions.filter((majcom) => majcom.squadron).map((majcom) => ({
        label: majcom.squadron,
        value: majcom.squadron
      }))
    ]

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION)
    }

    setSectionOptions(sectOptions)

    setDropdownValues((prev) => ({
      ...prev,
      section:
        sectOptions.length === 1 ? sectOptions[0].label : ALL_SELECT_LABEL,
      sectionCode:
        sectOptions.length === 1 ? sectOptions[0].value : ALL_SELECT_VALUE,
      servicingMAJCOM: e.label,
      servicingMAJCOMCode: e.value,
      squadron:
      squadOptions.length === 1 ? squadOptions[0].value : ALL_SELECT_VALUE,
    }))
  }

  const onSquadronChange = (e: { label: string; value: number }) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false
      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')
          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (sect.squadron === e.value || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })
      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]
      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })
    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    }
    setSectionOptions(sectOptions)
    setDropdownValues((prev) => ({
      ...prev,
      section:
        sectOptions.length === 1 ? sectOptions[0].label : ALL_SELECT_LABEL,
      sectionCode:
        sectOptions.length === 1 ? sectOptions[0].value : ALL_SELECT_VALUE,
      squadron: e.value,
    }))
  }

  function onSectionChange(e: { label: string; value: number }) {
    setDropdownValues((prevState) => ({
      ...prevState,
      sectionCode: e.value,
    }))
  }

  function addEditValue(showAddPopup: boolean): void {
    setShowAddPopup(showAddPopup)
  }
  /* Function call on edit */
  const onEdit = (item: any): void => {
    setInEditMode({
      rowKey: item.eKey,
      status: true,
    })
    setShowEdit(!showEdit)
  }
  /* Function call on cancel */
  const onCancel = () => {
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setShowEdit(!showEdit)
  }

  const onDelete = async (item: any) => {
    setClickedItem(item)

    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
  }
  const onClickAlert = async (button: string, item: any) => {
    if (button === 'OK') {
      setClickedItem(false)
      await deleteQuickLink(item)
      await fetchQuickLinks()
    } else {
      setClickedItem(false)
    }
  }

  useEffect(() => {
    let majcomValue = ALL_SELECT_OPTION.value
    let majcomLabel = ALL_SELECT_OPTION.label
    let assignedComponentValue = ALL_SELECT_OPTION.value
    let assignedComponentLabel = ALL_SELECT_OPTION.label
    let sectionLabel = ALL_SELECT_OPTION.label
    let sectionValue = ALL_SELECT_OPTION.value
    let squadronValue = ALL_SELECT_OPTION_STRING.value

    if (initialMajcomOptions.length === 1) {
      majcomValue = initialMajcomOptions[0].value
      majcomLabel = initialMajcomOptions[0].label
    }

    if (assignedComponentOptions.length === 1) {
      assignedComponentValue = assignedComponentOptions[0].value
      assignedComponentLabel = assignedComponentOptions[0].label
    }

    if (initialSectionOptions.length === 1) {
      sectionValue = initialSectionOptions[0].value
      sectionLabel = initialSectionOptions[0].label
    }

    if (initialSquadronOptions.length === 1) {
      squadronValue = initialSquadronOptions[0].value
    }

    setDropdownValues((prevState) => ({
      ...prevState,
      assignedComponent: assignedComponentLabel,
      assignedComponentCode: assignedComponentValue,
      section: sectionLabel,
      sectionCode: sectionValue,
      servicingMAJCOM: majcomLabel,
      servicingMAJCOMCode: majcomValue,
      squadron: squadronValue
    }))

  }, [assignedComponentOptions, initialSectionOptions, initialMajcomOptions])

  useEffect(() => {
    setMajcomOptions(initialMajcomOptions)
    setSectionOptions(initialSectionOptions)
  }, [initialMajcomOptions, initialSectionOptions])

  useEffect(() => {
    const filteredQuickLinks = quickLinks.filter(
      (quicklink) =>
        (dropdownValues.assignedComponentCode === -1 ||
          quicklink.AssignedComponentCode ===
          dropdownValues.assignedComponentCode) &&
        (dropdownValues.servicingMAJCOMCode === -1 ||
          quicklink.ServicingMAJCOMCode ===
          dropdownValues.ServicingMAJCOMCode) &&
        (dropdownValues.sectionCode === -1 ||
          quicklink.SectionCode === dropdownValues.sectionCode)
    )
    // setFilteredPointsOfContact(filteredPOC)
  }, [quickLinks, dropdownValues])
  return (
    <div className='row m-0'>
      {clickedItem && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={DELETE_MESSAGE}
          onClick={(e) => onClickAlert(e, clickedItem)}
          yes='OK'
        />
      )}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center flex-wrap settingsfilters'>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='AssignComponent'
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignComponentChange}
                options={assignedComponentOptions}
                value={dropdownValues.assignedComponentCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingMAJCOM'
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMAJCOMChange}
                options={majcomOptions}
                value={dropdownValues.servicingMAJCOMCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingOrganization'
                label='Servicing Organization'
                name='Servicing Organization'
                onChange={onSquadronChange}
                options={squadronOptions}
                value={dropdownValues.squadron}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='Section'
                label='Section'
                name='Section'
                onChange={onSectionChange}
                options={sectionOptions}
                value={dropdownValues.sectionCode}
              />
            </div>
            <div className='dividerdashed vertical mx-1 mx-lg-2 d-none d-md-block'></div>
            <div className='ms-2 ms-sm-auto my-sm-2'>
              <Buttons
                aria-label='ADD'
                className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold settingsaddbtn'
                icon='icon-add me-xl-1 font-11'
                label='ADD'
                onClick={() => {
                  setShowAddPopup(!showAddPopup)
                }}
              />
            </div>
          </div>
        }
        name='Quick Links'
      />
      <div className='p-0 settings-main mt-2'>
        {showAddPopup && (
          <AddEditView
            assignedComponentOptions={assignedComponentOptions}
            cancel={() => onCancel()}
            closePopup={addEditValue}
            components={components}
            fetchQuickLinks={fetchQuickLinks}
            initialMajcomOptions={initialMajcomOptions}
            initialSectionOptions={initialSectionOptions}
            majcoms={majcoms}
            roleContext={roleContext}
            sections={sections}
            showAddPopup={showAddPopup}
            toggleView={() => {
              setShowAddPopup(!showAddPopup)
            }}
            visibleSquadrons={visibleSquadrons}
          />
        )}
        {quickLinks.length > 0 ? (
          <div>
            {quickLinks?.map((quicklink: any, index) => {
              return (
                <div
                  className='d-flex flex-column shadow card poppins-medium mb-2 py-3 my-2 mx-2'
                  key={quicklink.Title}
                >
                  <div className='d-flex px-2'>
                    <div className='d-flex flex-column flex-md-row flex-wrap w-100  align-items-center'>
                      <div aria-live='polite' className='d-flex flex-column min-w-100  w-100 max-w-200 my-2' tabIndex={0} title={quicklink.Title}>
                        <div className='title-color35 poppins-semibold font-12'>
                          Name
                        </div>
                        <div className='poppins-semibold font-12 title-color2'>
                          {quicklink.Title}
                        </div>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                      <div aria-live='polite' className='d-flex flex-column me-auto text-wrap my-2' tabIndex={0} title={quicklink.Url}>
                        <div className='title-color35 poppins-semibold font-12'>
                          Url
                        </div>
                        <div className='poppins-semibold font-12 color-primary links-over-underline links cursor'>
                          <a href={quicklink.Url} rel='noreferrer' target='_blank' title={quicklink.Url}>
                            {quicklink.Url}
                          </a>
                        </div>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                      <div aria-live='polite' className='d-flex flex-column me-auto text-wrap my-2' tabIndex={0} title={quicklink?.['AssignedComponent/MetadataValue'] || 'All'}>
                        <div className='title-color35 poppins-semibold font-12'>
                          Assigned Component
                        </div>
                        <div className='poppins-semibold font-12 title-color2'>
                          {quicklink?.['AssignedComponent/MetadataValue'] || 'All'}
                        </div>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                      <div aria-live='polite' className='d-flex flex-column me-auto text-wrap my-2' tabIndex={0} title={quicklink?.['ServicingMAJCOM/MetadataValue'] || 'All'}>
                        <div className='title-color35 poppins-semibold font-12'>
                          Servicing MAJCOM
                        </div>
                      <div className='poppins-semibold font-12 title-color2'>
                        {quicklink?.['ServicingMAJCOM/MetadataValue'] || 'All'}
                      </div>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                      <div aria-live='polite' className='d-flex flex-column me-auto text-wrap my-2' tabIndex={0} title={quicklink?.Squadron || 'All'}>
                        <div className='title-color35 poppins-semibold font-12'>
                          Servicing Organization
                        </div>
                      <div className='poppins-semibold font-12 title-color2'>
                        {quicklink?.Squadron || 'All'}
                      </div>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                      <div aria-live='polite' className='d-flex flex-column me-auto text-wrap my-2' tabIndex={0} title={quicklink?.Section?.join(', ')}>
                        <div className='title-color35 poppins-semibold font-12'>
                          Section
                        </div>
                        <div className='poppins-semibold font-12 title-color2'>
                          {quicklink?.Section?.length === 0 ? 'All' : quicklink?.Section?.join(', ')}
                        </div>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                      <div aria-live='polite' className='d-flex flex-column min-w-100  w-100 max-w-80 my-2' tabIndex={0} title={quicklink.IsArchived ? 'Yes' : 'No'}>
                        <div className='title-color35 poppins-semibold font-12'>
                          Is Archived
                        </div>
                        <div className='poppins-semibold font-12 title-color2'>
                          {quicklink.IsArchived ? 'Yes' : 'No'}
                        </div>
                      </div>
                      <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                    </div>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex gap-1 settings-actionbtns mx-2 mx-xxl-3'>
                        <Buttons
                          aria-label='Edit'
                          className={
                            inEditMode.status &&
                              inEditMode.rowKey === quicklink.eKey
                              ? 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto bgcolor-primary whitetext text-nowrap sourcesansprosemibold active'
                              : 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                          }
                          icon='icon-pencil me-xl-1 font-10'
                          label='Edit'
                          onClick={() => onEdit(quicklink)}
                        />
                        <Buttons
                          aria-label='Delete'
                          className='btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                          icon='icon-trashbin me-xl-1 font-10'
                          label='Delete'
                          onClick={() => onDelete(quicklink)}
                        />
                      </div>
                    </div>
                  </div>
                  {inEditMode.status && inEditMode.rowKey === quicklink.eKey ? (
                    <AddEditView
                      assignedComponentOptions={assignedComponentOptions}
                      cancel={() => onCancel()}
                      clickedIndex={index}
                      components={components}
                      editQuickLink={quicklink}
                      fetchQuickLinks={fetchQuickLinks}
                      initialMajcomOptions={initialMajcomOptions}
                      initialSectionOptions={initialSectionOptions}
                      majcoms={majcoms}
                      roleContext={roleContext}
                      sections={sections}
                      showAddPopup={showAddPopup}
                      showEdit={showEdit}
                      toggleView={() => setClickedItem(false)}
                      visibleSquadrons={visibleSquadrons}
                    />
                  ) : (
                    ''
                  )}
                </div>
              )
            })}
          </div>
        ) : (
          <div>
          <NO_RESULTS/>
          </div>
        )}
      </div>
    </div>
  )
}
export default SettingsQuicklinks
